<template>
  <div class="p-5 pt-5 h-screen">
    <form @submit.prevent="actualizar" class="px-8 pt-6 pb-8 content-start">
      <div class="mb-6">
        <input
          class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          v-model="email"
          type="text"
          placeholder="Email"
        />
      </div>
      <div class="mb-6">
        <input
          class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          v-model="apellido"
          type="text"
          placeholder="Apellido"
        />
      </div>
      <div class="mb-6">
        <input
          class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          v-model="nombre"
          type="text"
          placeholder="Nombre"
        />
      </div>
      <div class="mb-6">
        <input
          class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          v-model="dni"
          type="number"
          placeholder="DNI"
        />
      </div>
      <div class="mb-6">
        <input
          class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          v-model="telefono"
          type="text"
          placeholder="Teléfono"
        />
      </div>
      <button class="bg-paleta-4 text-white font-bold py-2 px-4 rounded justify-left" @click.prevent="fotoDni">
        Sacar foto DNI
      </button>
      <img :src="contenidoImagenDni" />
      <div class="flex mt-3">
        <button class="bg-paleta-3 text-white font-bold py-2 px-4 rounded justify-left">
          Actualizar
        </button>
      </div>
    </form>
    <div v-if="datosActualizacion.mensajeError" class="text-white">
      {{ datosActualizacion.mensajeError }}
    </div>
    <div v-if="errorValidacion" class="text-white">
      {{ errorValidacion }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: function() {
    return {
      token: "",
      email: "",
      apellido: "",
      nombre: "",
      dni: "",
      telefono: "",
      contenidoImagenDni: "",
      errorValidacion: "",
      submitted: false
    };
  },
  mounted() {
    this.token = this.datosActualizacion.token;
    this.email = this.datosActualizacion.email;
    this.apellido = this.datosActualizacion.apellido;
    this.nombre = this.datosActualizacion.nombre;
    this.dni = this.datosActualizacion.dni;
    this.telefono = this.datosActualizacion.telefono;
    if (this.fotoDniTemporal) {
      this.contenidoImagenDni = "data:image/png;base64," + this.fotoDniTemporal;
    } else {
      this.contenidoImagenDni = "";
    }
  },
  methods: {
    fotoDni() {
      this.$store.commit("guardarDatosPersonalesTemporalmente", {
        email: this.email,
        apellido: this.apellido,
        nombre: this.nombre,
        dni: this.dni,
        telefono: this.telefono,
        origen: "Externo"
      });
      this.$router.push("/miCuenta/datosPersonales/dni");
    },
    actualizar() {
      this.submitted = true;

      if (!this.email) {
        this.errorValidacion = "Debe especificar el email";
        return;
      }

      if (!this.apellido) {
        this.errorValidacion = "Debe especificar el apellido";
        return;
      }

      if (!this.nombre) {
        this.errorValidacion = "Debe especificar el nombre";
        return;
      }

      if (!this.dni) {
        this.errorValidacion = "Debe especificar el número de DNI";
        return;
      }

      if (!this.telefono) {
        this.errorValidacion = "Debe especificar el número de teléfono";
        return;
      }

      if (!this.fotoDniTemporal) {
        this.errorValidacion = "Debe incluir una foto del DNI";
        return;
      }

      this.$store.dispatch("actualizarDatosPersonalesExterno");
    }
  },
  computed: {
    ...mapState({
      datosActualizacion: state => state.actualizarDatosPersonales,
      fotoDniTemporal: state => state.actualizarDatosPersonales.fotoDni
    })
  }
};
</script>
